// @styles
require('./amazonCouponCodeTableRow.scss');

// @ Vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @ Helpers
const { getLanguage, FormattedText, formatText } = require('core/i18n').i18n;
const currencyHelper = require('utilities/currencyHelper');

// @actions
const amazonGiftCardActions = require('actions/amazonGiftCard');

// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { sendTextToClipBoard } = require('commonsUtilities/clipBoardHelper');

// @components
const { LabelDate } = require('commonsComponents/labelDate');
const { OKLink } = require('commonsComponents/OKLink');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

// @constants
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');
const { AMAZON_GIFT_CARD_STATUS, HYPHEN, EURO_TEXT } = require('constants/index');
const { AMAZON_CODIGOS, AMAZON_GIFT_CARD_COUPEN_CODE_RETRY } = require('constants/tagging');

//@utils
const { recordLinkV2 } = require("utilities/tagging");

class AmazonCouponCodeTableRow extends React.Component {
    constructor(props) {
        super(props);

        this.handleRowClick = this.handleRowClick.bind(this);
    }

    handleReturnGiftCardButtonClick = (giftCardDetails) => {
        const pathArray = window.location.pathname.split('/');
        const accountId = pathArray[pathArray.length-2];
        this.props.history.push(`/myprofile/accounts/${accountId}/amazon-gift-check-return`);
        this.props.sendAmazonGiftCardReturnDetails(giftCardDetails);
        const customData = ({
            categoriaEvento: AMAZON_CODIGOS,
            accionEvento: "devolver cheque"
        });
        recordLinkV2(customData);
    }

    handleRowClick(giftAmount, giftVoucherRequestId, id, etiquetaEvento) {
        this.props.onRowClick(giftAmount, giftVoucherRequestId, id);
        let customData;

        if(etiquetaEvento == AMAZON_GIFT_CARD_COUPEN_CODE_RETRY) {
            customData = ({
                categoriaEvento: AMAZON_CODIGOS,
                accionEvento: "error ver codigo",
                etiquetaEvento,
                nombrePagina: AMAZON_CODIGOS
            });
        } else {
            customData = ({
                categoriaEvento: AMAZON_CODIGOS,
                accionEvento: "ver codigos",
                nombrePagina: AMAZON_CODIGOS
            });
        }
        recordLinkV2(customData);
    }

    buildCodeErrorSection = (giftAmount, giftVoucherRequestId) => {
        const { id } = this.props;

        return (
            <React.Fragment>
                <FormattedText value="amazonGiftCard-codeErrorDescription" />
                <div className="amazon-coupon-code-table-row__retry-btn">
                    <OKLink
                        modifier="emphasize"
                        onClick={() => this.handleRowClick(giftAmount, giftVoucherRequestId, id, AMAZON_GIFT_CARD_COUPEN_CODE_RETRY)}
                    >
                        <FormattedText value="common-retry" />
                    </OKLink>
                </div>
            </React.Fragment>
        );
    }

    handleCopyIconClick = (e, giftCardPromoCode) => {
        e.preventDefault();
        sendTextToClipBoard(giftCardPromoCode);
        this.props.showNotification(formatText("amazonGiftCard-copySnackbarText"));
    }

    buildCopyIcon = (giftCardPromoCode) => {
        return (
            <button
                className="icon__tooltip icon-copiar amazon-coupon-code-table-row__copy-icon"
                onClick={(e) => this.handleCopyIconClick(e, giftCardPromoCode)}>
            </button>
        );
    }

    render() {
        const { immTransaction, id, immAmazonGiftCard } = this.props;
        const currency = currencyHelper.formatCurrency(EURO_TEXT);
        const giftVoucherAmount = Number(immTransaction.get('gift')) || HYPHEN;
        const giftAmount = immTransaction.get('gift');
        const giftVoucherRequestId = immTransaction.get('requestId');
        const numerodecontrato = immTransaction.get('numerodecontrato');
        const giftVoucherAmountObject = {
            amount: giftVoucherAmount,
            currency: currency
        };
        const formattedGiftVoucherAmount = (<OneLineSymbolAmount
            amountObject={giftVoucherAmountObject}
            amountObjectFormatted={currencyHelper.formatAmountObject(giftVoucherAmountObject, true)}
        />);
        const giftCardPromoCode = immAmazonGiftCard.getIn(['promoCodeById', id, 'promocode']);
        const cardStatus = immTransaction.get('cardStatus');
        let promoCode;

        if (immAmazonGiftCard.get('promoCodeSuccess') && giftCardPromoCode) {
            promoCode = (
                <React.Fragment>
                    {giftCardPromoCode}
                    {this.buildCopyIcon(giftCardPromoCode)}
                </React.Fragment>
            );
        }

        if (immAmazonGiftCard.get('promoCodeError') && immAmazonGiftCard.getIn(['errorById', id, 'error'])) {
            promoCode = this.buildCodeErrorSection(giftAmount, giftVoucherRequestId);
        }

        if (immAmazonGiftCard.get('promoCodeIsFetching') && immAmazonGiftCard.getIn(['ShowLoader', id, 'promoCodeFetchingLoader'])) {
            promoCode = <LoadingSection />;
        }

        let promoCodeContent;
        const showCodeLink = immTransaction.get('showCodeLink');

        if (cardStatus === AMAZON_GIFT_CARD_STATUS) {
            promoCodeContent = (<p className="amazon-coupon-code-table-row__code-cancelled">
                <FormattedText value="amazonGiftCardReturn-cancelledCodeText" />
            </p>)
        } else if (!!promoCode) {
            promoCodeContent = promoCode;
        } else if (showCodeLink) {
            promoCodeContent = (<OKLink
                modifier="emphasize"
                onClick={() => this.handleRowClick(giftAmount, giftVoucherRequestId, id)}
            >
                <FormattedText value="amazonGiftCard-amazonGiftCard_voucherCodeLink" />
            </OKLink>);
        }

        let returnGiftCardButton;
        const showReturnGiftCardButton = immTransaction.get('eligibleToCancel') &&
                                        (cardStatus && cardStatus !== AMAZON_GIFT_CARD_STATUS) &&
                                        numerodecontrato;

        const giftCardDetails = {
            giftAmount,
            giftVoucherRequestId,
            numerodecontrato
        }

        if (!!showReturnGiftCardButton) {
            returnGiftCardButton = (<button
                className="amazon-coupon-code-table-row__return-gift-card-btn"
                onClick={() => this.handleReturnGiftCardButtonClick(giftCardDetails)}
            >
                <FormattedText value="amazonGiftCardReturn-button" />
            </button>);
        }

        return (<OKTableRow key={id}>
            <OKTableCell>
                <LabelDate
                    date={immTransaction.get('creationDate')}
                    language={getLanguage()}
                    today={LABEL_DATE_TODAY}
                    yesterday={LABEL_DATE_YESTERDAY}
                />
            </OKTableCell>
            <OKTableCell>
                <FormattedText value="amazonGiftCard-promotionText" />
                <div className="amazon-coupon-code-table-row__return-card">
                    {returnGiftCardButton}
                </div>
            </OKTableCell>
            <OKTableCell>
                <div className="amazon-coupon-code-table-row__promo-code">
                    {promoCodeContent}
                </div>
            </OKTableCell>
            <OKTableCell>
                <div className="amazon-coupon-code-table-row__gift-amount">
                    {formattedGiftVoucherAmount}
                </div>
            </OKTableCell>
        </OKTableRow>
        );
    }
}

AmazonCouponCodeTableRow.propTypes = {
    history: PropTypes.object.isRequired,
    id: PropTypes.string,
    immAmazonGiftCard: PropTypes.object,
    immTransaction: PropTypes.object,
    onRowClick: PropTypes.func,
    reset: PropTypes.func.isRequired,
    sendAmazonGiftCardReturnDetails: PropTypes.func,
    showNotification: PropTypes.func,
};

AmazonCouponCodeTableRow.defaultProps = {
    className: '',
    onRowClick: function () { }
};

module.exports = connect(
    state => ({
        immAmazonGiftCard: state.amazonGiftCards
    }),
    {
        sendAmazonGiftCardReturnDetails: amazonGiftCardActions.sendAmazonGiftCardReturnDetails,
        showNotification: amazonGiftCardActions.showNotification,
    }
)(withRouter(AmazonCouponCodeTableRow));
